import { render } from "./HeaderBlock.vue?vue&type=template&id=c5b98992&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"

import "./HeaderBlock.vue?vue&type=style&index=0&id=c5b98992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b98992"]])

export default __exports__